/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {QualityGradingModelOverviewTable} from '../bioplanModels';
/**
 * QualityGradingModelsOverviewTableApi - axios parameter creator
 * @export
 */
export const QualityGradingModelsOverviewTableApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} date
     * @param {string} [cageId]
     * @param {string} [siteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelsOverviewTableGet: async (
      date: string,
      cageId?: string,
      siteId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'date' is not null or undefined
      assertParamExists('qualityGradingModelsOverviewTableGet', 'date', date);
      const localVarPath = `/qualityGradingModelsOverviewTable/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (cageId !== undefined) {
        localVarQueryParameter['cageId'] = cageId;
      }

      if (siteId !== undefined) {
        localVarQueryParameter['siteId'] = siteId;
      }

      if (date !== undefined) {
        localVarQueryParameter['date'] =
          (date as any) instanceof Date ? (date as any).toISOString().substring(0, 10) : date;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * QualityGradingModelsOverviewTableApi - functional programming interface
 * @export
 */
export const QualityGradingModelsOverviewTableApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = QualityGradingModelsOverviewTableApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} date
     * @param {string} [cageId]
     * @param {string} [siteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async qualityGradingModelsOverviewTableGet(
      date: string,
      cageId?: string,
      siteId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QualityGradingModelOverviewTable>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.qualityGradingModelsOverviewTableGet(
        date,
        cageId,
        siteId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QualityGradingModelsOverviewTableApi.qualityGradingModelsOverviewTableGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * QualityGradingModelsOverviewTableApi - factory interface
 * @export
 */
export const QualityGradingModelsOverviewTableApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = QualityGradingModelsOverviewTableApiFp(configuration);
  return {
    /**
     *
     * @param {QualityGradingModelsOverviewTableApiQualityGradingModelsOverviewTableGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelsOverviewTableGet(
      requestParameters: QualityGradingModelsOverviewTableApiQualityGradingModelsOverviewTableGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<QualityGradingModelOverviewTable> {
      return localVarFp
        .qualityGradingModelsOverviewTableGet(
          requestParameters.date,
          requestParameters.cageId,
          requestParameters.siteId,
          options,
        )
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for qualityGradingModelsOverviewTableGet operation in QualityGradingModelsOverviewTableApi.
 * @export
 * @interface QualityGradingModelsOverviewTableApiQualityGradingModelsOverviewTableGetRequest
 */
export interface QualityGradingModelsOverviewTableApiQualityGradingModelsOverviewTableGetRequest {
  /**
   *
   * @type {string}
   * @memberof QualityGradingModelsOverviewTableApiQualityGradingModelsOverviewTableGet
   */
  readonly date: string;

  /**
   *
   * @type {string}
   * @memberof QualityGradingModelsOverviewTableApiQualityGradingModelsOverviewTableGet
   */
  readonly cageId?: string;

  /**
   *
   * @type {string}
   * @memberof QualityGradingModelsOverviewTableApiQualityGradingModelsOverviewTableGet
   */
  readonly siteId?: string;
}

/**
 * QualityGradingModelsOverviewTableApi - object-oriented interface
 * @export
 * @class QualityGradingModelsOverviewTableApi
 * @extends {BaseAPI}
 */
export class QualityGradingModelsOverviewTableApi extends BaseAPI {
  /**
   *
   * @param {QualityGradingModelsOverviewTableApiQualityGradingModelsOverviewTableGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QualityGradingModelsOverviewTableApi
   */
  public qualityGradingModelsOverviewTableGet(
    requestParameters: QualityGradingModelsOverviewTableApiQualityGradingModelsOverviewTableGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return QualityGradingModelsOverviewTableApiFp(this.configuration)
      .qualityGradingModelsOverviewTableGet(
        requestParameters.date,
        requestParameters.cageId,
        requestParameters.siteId,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }
}
